import React, { createContext, FC, PropsWithChildren, useContext, useState } from 'react';
import { LoadingOverlayBlocker } from './loading-overlay-blocker';

export const LoadingOverlayBlockerContext = createContext<LoadingOverlayBlockerContextModel | undefined>(undefined);

interface LoadingOverlayBlockerContextModel {
  loadingOverlayVisible: boolean;
  setLoadingOverlayVisible: (visible: boolean) => void;
}

export const LoadingOverlayContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);

  return (
    <LoadingOverlayBlockerContext.Provider value={{ loadingOverlayVisible, setLoadingOverlayVisible }}>
      {children}
      <LoadingOverlayBlocker />
    </LoadingOverlayBlockerContext.Provider>
  );
};

export const useLoadingOverlayBlocker = () => {
  const context = useContext(LoadingOverlayBlockerContext);

  if (!context) {
    throw new Error(`useLoadingOverlayBlocker must be used within a LoadingOverlayBlockerContextProvider`);
  }

  return context;
};
